module.exports = __webpack_public_path__ + "media/images/home/security-1-6f21ca22cb01610bc70367c59623cc45.png";